"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarGroup", {
    enumerable: true,
    get: function() {
        return ToolbarGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToolbarGroup = require("./useToolbarGroup");
const _useToolbarGroupStylesstyles = require("./useToolbarGroupStyles.styles");
const _renderToolbarGroup = require("./renderToolbarGroup");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbarGroup.useToolbarGroup_unstable)(props, ref);
    (0, _useToolbarGroupStylesstyles.useToolbarGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarGroupStyles_unstable')(state);
    return (0, _renderToolbarGroup.renderToolbarGroup_unstable)(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
ToolbarGroup.displayName = 'ToolbarGroup';
